export const About = () => {
  return (
    <section id='about' className='bd-container'>
      <div className='section-container'>
        <h1>À propos</h1>
        <h2 className='subtitle'>Nous avons conçu un outil de détection automatisé d’objets grâce à l’intelligence
          artificielle. </h2>
        <p>BPartners est une startup issue de la recherche française.
          Labélisée entreprise DeepTech pour avoir conçu un outil de détection et mesure d’objets pour les artisans
          pour
          leur simplifier la vie.
        </p>
        <p>Cette technologie a été étendue aux collectivités et grandes groupes pour répondre à leur besoin de
          détecter
          des objets d’intérêts sur mieux connaitre leur territoires et suivre son évolution.
        </p>
        <p>Le projet est portée par une équipe de docteurs en intelligence artificielle.</p>
      </div>
    </section>
  );
};